import React, { useEffect, useState } from 'react';
import firebase from '../../config/firebase.config';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import styles from './InviteesList.module.scss';
import { Table } from '@/components/Table';
import { EmptyState } from '@/components/EmptyState';
import { teamInviteListConfig } from './InviteesList.config';
const database = firebase.firestore();

export const InviteesListComponent = () => {
  const { profile } = useSelector((state) => state.auth);
  const [inviteData, setInviteData] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [isList, setIsList] = useState(true);
  const [empty, setEmpty] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  // get User Data
  const getUser = async () => {
    setInviteData([]);
    try {
      await database
        .collection('membersDatabase')
        .where('accountEmailid', '==', profile?.email)
        .get()
        .then((memberData) => {
          const data = memberData.docs.map((res) => res.data());
          if (data[0]?.teamInvites?.length === 0) {
            setIsList(true);
          } else {
            setEmpty(false);
            for (let i = 0; i <= data[0]?.teamInvites?.length; i++) {
              try {
                database
                  .collection('userInvites')
                  .doc(data[0].teamInvites[i])
                  .get()
                  .then((response) => {
                    if (response.data() !== undefined) {
                      setInviteData((old) => [
                        ...old,
                        {
                          data: response.data(),
                          docId: data[0].teamInvites[i],
                        },
                      ]);
                    }
                  });
              } catch (error) {
                return error;
              }
            }
          }
        });
    } catch (error) {
      return error;
    }
    setIsList(false);
  };

  const openModal = (docId) => {
    history.push(`invites/${docId}`);
  };

  useEffect(() => {
    localStorage.removeItem('ItemCount');
    localStorage.setItem('Visited', true);
    if (profile?.companyList?.length === 1) {
      if ('list' in localStorage) {
        const list = localStorage.getItem('list');
        localStorage.removeItem('list');
        if (list === 1) {
          localStorage.setItem('teamData', []);
          dispatch({
            type: teamActionTypes.SWITCH_COMPANY_ACTIVE_TEAM,
            payload: {
              companyId: profile?.companyList[0].companyId,
              userId: profile?.id,
            },
          });
        }
      }
    }
    getUser();
  }, []);
  const getTeamInviteTableData = () => {
    const tableData = [];
    inviteData.forEach((invite, key) => {
      if (!invite?.data?.declined) {
        tableData.push({
          id: key + 1,
          role: invite?.data?.invitedAs,
          invitedBy: invite?.data?.invitedBy?.fullName,
          company: invite?.data?.invitedBy?.companyDetails?.companyName,
          team: invite?.data?.invitedTo?.teamName,
          docId: invite?.docId,
        });
      }
    });
    return tableData;
  };
  useEffect(() => {
    setTableData(getTeamInviteTableData());
  }, [inviteData]);
  return (
    <>
      <div className={styles.inviteesListPage}>
        {tableData.length === 0 ? (
          <EmptyState
            illustration
            title="No Invites Found"
            description="You don't have any invites to review right now."
          />
        ) : (
          <Table
            className={styles.table}
            data={tableData}
            columns={teamInviteListConfig(openModal)}
          />
        )}
      </div>
    </>
  );
};
